import { render, staticRenderFns } from "./MagicCodeComponent.vue?vue&type=template&id=1c4087c6&scoped=true"
import script from "./MagicCodeComponent.vue?vue&type=script&lang=js"
export * from "./MagicCodeComponent.vue?vue&type=script&lang=js"
import style0 from "./MagicCodeComponent.vue?vue&type=style&index=0&id=1c4087c6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../ct-id-20261026/vue/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c4087c6",
  null
  
)

export default component.exports